import { ChangeDetectorRef, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { SimpleDropdownOption } from '@components/simple-dropdown/simple-dropdown.component';
import {
    OutputSettingType,
    OutputAddress,
    SettingsAddress,
    OutputSettingMode,
    SignalWidthMin,
    SignalWidthDefault,
    SignalWidthMax,
} from 'icreate/common/models/alarm-group';
import { SensorTagSlot } from 'icreate/common/models/sensor-cable-tag';
import { outputAddressValidator } from 'icreate/common/validators/alarm-group/alarm-group-validator';

@Component({
    selector: 'app-output-setting',
    templateUrl: './output-setting.component.html',
    styleUrl: './output-setting.component.css',
    standalone: false,
})
export class OutputSettingComponent {
    readonly TYPE_OPTIONS: SimpleDropdownOption[] = [
        { value: OutputSettingType.ONE_SHOT, string: 'output-type.one-shot' },
        { value: OutputSettingType.CONTINUOUS, string: 'output-type.continuous' },
        { value: OutputSettingType.FLASHING, string: 'output-type.flashing' },
        { value: OutputSettingType.BUZZER, string: 'output-type.buzzer' },
    ];
    readonly MODE_OPTIONS = [
        { value: OutputSettingMode.FUNCTION, string: 'output-mode.function' },
        { value: OutputSettingMode.LAMP, string: 'output-mode.lamp' },
        { value: OutputSettingMode.BOTH, string: 'output-mode.both' },
        { value: OutputSettingMode.NEITHER, string: 'output-mode.neither' },
    ];
    readonly SIGNAL = 'signal';

    @Input() outputSetting: OutputAddress;
    @Input() vesselSlots: SensorTagSlot[];
    @Output() onDeleteSetting: EventEmitter<void> = new EventEmitter();

    constructor(private cdr: ChangeDetectorRef) {}

    handleTypeChanged(type: SimpleDropdownOption) {
        this.outputSetting.type = type.value;
        if (type.value !== OutputSettingType.ONE_SHOT) this.outputSetting.signal = null;
        else if (!this.outputSetting.signal) this.outputSetting.signal = SignalWidthDefault;
        event.stopImmediatePropagation();
        this.cdr.detectChanges();
    }

    handleModeChanged(mode: SimpleDropdownOption) {
        this.outputSetting.mode = mode.value;
        event.stopImmediatePropagation();
        this.cdr.detectChanges();
    }

    handleSelectorsChange(settingsAddress: SettingsAddress) {
        this.outputSetting.address = settingsAddress;
    }

    handleSignalChange(newSignalWidth) {
        if (this.isOneShot) this.outputSetting.signal = Number(newSignalWidth);
    }

    deleteSetting() {
        if (this.outputSetting.index == 1) return;
        this.onDeleteSetting.emit();
    }

    get selectorsAreDisabled() {
        if (this.isOneShot) {
            if (!this.outputSetting.signal) return true;
            return this.outputSetting.signal < SignalWidthMin || this.outputSetting.signal > SignalWidthMax;
        }
        return !this.outputSetting.type;
    }

    get isOneShot() {
        if (!this.outputSetting.type) return false;
        return this.outputSetting.type == OutputSettingType.ONE_SHOT;
    }

    get validatorFunction() {
        return outputAddressValidator();
    }
}
